/**
 * Web i18n namespaces.
 */
export enum Ns {
    Actions = 'actions',
    Articleblock = 'articleblock',
    Articles = 'articles',
    Author = 'author',
    Betting = 'betting',
    Comments = 'comments',
    Common = 'common',
    Competitions = 'competitions',
    Components = 'components',
    CreatePost = 'create-post',
    Contact = 'contact',
    Datetime = 'datetime',
    Error = 'error',
    Footer = 'footer',
    Image = 'image',
    Livescores = 'livescores',
    Meta = 'meta',
    Names = 'names',
    Newslist = 'newslist',
    PlayerRating = 'player-rating',
    PostComment = 'post-comment',
    Premium = 'premium',
    Profile = 'profile',
    RelatedNews = 'related-news',
    Search = 'search',
    Secure = 'secure',
    Sidebar = 'sidebar',
    Standing = 'standing',
    Stats = 'stats',
    Subscribe = 'subscribe',
    UploadSpots = 'upload-spots',
    Url = 'url',
    User = 'user',
    Videos = 'videos',
}
